import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiStar,FiShield,FiClock,FiUsers,FiZap,FiTrendingUp,FiAward,FiPhone,FiMail}=FiIcons;

function BookConsultation() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Header Section */}
      <section className="py-12 bg-gradient-to-r from-blue-900 via-blue-800 to-green-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757818262760-Untitled%20design%20%282%29.png"
                alt="AllGrowth"
                className="h-10 w-auto"
              />
              <div className="text-white">
                <span className="text-3xl font-bold">AllGrowth</span>
                <div className="text-sm text-blue-200">by Handvantage</div>
              </div>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              Schedule Your Strategy Call
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Book a complimentary 30-minute consultation with our growth experts and discover how AllGrowth can transform your business
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-8">
            {/* Left Sidebar - Benefits */}
            <div className="lg:col-span-4 space-y-6">
              {/* What You'll Get */}
              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <SafeIcon icon={FiStar} className="h-6 w-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">What You'll Get</h3>
                </div>
                <ul className="space-y-3">
                  {[
                    'Business growth assessment',
                    'Custom marketing strategy roadmap',
                    'Competitive analysis insights',
                    'ROI projections for your business',
                    'Implementation timeline and next steps'
                  ].map((item,idx)=> (
                    <li key={idx} className="flex items-start space-x-3">
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Trust Indicators */}
              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 border border-green-200">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Why Business Owners Trust Us</h3>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiUsers} className="h-5 w-5 text-green-600" />
                    <span className="text-gray-700">500+ businesses transformed</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiTrendingUp} className="h-5 w-5 text-green-600" />
                    <span className="text-gray-700">Average 150% growth increase</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiAward} className="h-5 w-5 text-green-600" />
                    <span className="text-gray-700">98% client satisfaction rate</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiShield} className="h-5 w-5 text-green-600" />
                    <span className="text-gray-700">No-obligation consultation</span>
                  </div>
                </div>
              </div>

              {/* Testimonial */}
              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="flex items-center mb-3">
                  {[...Array(5)].map((_,i)=> (
                    <SafeIcon key={i} icon={FiStar} className="h-4 w-4 text-yellow-400" />
                  ))}
                </div>
                <blockquote className="text-gray-700 italic mb-4">
                  "AllGrowth transformed our marketing completely. We went from struggling to find customers to having more leads than we can handle. Best investment we've made for our business."
                </blockquote>
                <div className="text-sm">
                  <div className="font-semibold text-gray-900">Sarah Johnson</div>
                  <div className="text-gray-600">CEO,Johnson & Associates</div>
                </div>
              </div>

              {/* Contact Info */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Need Help Booking?</h3>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiPhone} className="h-4 w-4 text-blue-600" />
                    <a href="tel:+12362350919" className="text-blue-600 hover:text-blue-700">
                      +1 (236) 235-0919
                    </a>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiMail} className="h-4 w-4 text-blue-600" />
                    <a href="mailto:info@handvantage.com" className="text-blue-600 hover:text-blue-700">
                      info@handvantage.com
                    </a>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiClock} className="h-4 w-4 text-blue-600" />
                    <span className="text-gray-700">Available 9 AM - 6 PM PST</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Center - Booking Widget */}
            <div className="lg:col-span-8">
              <div className="bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-green-600 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-xl font-bold text-white">Book Your Consultation</h2>
                      <p className="text-blue-100">Choose a time that works best for you</p>
                    </div>
                    <div className="flex items-center space-x-2 bg-white/20 rounded-lg px-3 py-1">
                      <SafeIcon icon={FiZap} className="h-4 w-4 text-white" />
                      <span className="text-white text-sm font-medium">30 Minutes</span>
                    </div>
                  </div>
                </div>

                {/* Iframe Container */}
                <div className="relative" style={{minHeight: '600px',height: '70vh'}}>
                  <iframe
                    src="https://clickntalk.allgrowthco.net/expert/ayomide.oluwaga"
                    allow="camera;microphone;fullscreen;autoplay;display-capture"
                    frameBorder="0"
                    scrolling="no"
                    style={{minWidth: '360px',minHeight: '600px',width: '100%',height: '100%',border: 'none'}}
                    title="AllGrowth Consultation Booking"
                  />
                </div>
              </div>

              {/* Additional Info Below Iframe */}
              <div className="mt-6 grid md:grid-cols-3 gap-4">
                <div className="bg-white rounded-lg p-4 shadow-md text-center">
                  <SafeIcon icon={FiShield} className="h-8 w-8 text-green-500 mx-auto mb-2" />
                  <div className="font-semibold text-gray-900">100% Complimentary</div>
                  <div className="text-sm text-gray-600">No hidden fees or obligations</div>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md text-center">
                  <SafeIcon icon={FiClock} className="h-8 w-8 text-blue-500 mx-auto mb-2" />
                  <div className="font-semibold text-gray-900">30 Minutes</div>
                  <div className="text-sm text-gray-600">Focused,valuable consultation</div>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md text-center">
                  <SafeIcon icon={FiUsers} className="h-8 w-8 text-purple-500 mx-auto mb-2" />
                  <div className="font-semibold text-gray-900">Expert Team</div>
                  <div className="text-sm text-gray-600">Talk directly with our specialists</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
          </div>
          <div className="space-y-6">
            {[
              {question: 'What happens during the consultation?',answer: 'We\'ll analyze your current marketing situation,identify growth opportunities,and create a custom strategy roadmap for your business. You\'ll get actionable insights whether you work with us or not.'},
              {question: 'Is this really complimentary with no strings attached?',answer: 'Absolutely. This is a genuine consultation to help you understand your marketing opportunities. There\'s no sales pressure,and you\'ll receive valuable insights regardless of whether you choose to work with us.'},
              {question: 'How quickly will I see results if I work with AllGrowth?',answer: 'Most clients start seeing increased website traffic within 30-60 days,with significant lead generation improvements within 90 days. We\'ll give you realistic timelines based on your specific situation.'},
              {question: 'What if I need to reschedule my appointment?',answer: 'No problem! You can easily reschedule using the booking system above,or contact us directly. We understand that business schedules can be unpredictable.'}
            ].map((faq,index)=> (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {faq.question}
                </h3>
                <p className="text-gray-600">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-12 bg-gradient-to-r from-blue-900 to-green-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-blue-100 mb-6">
            Join hundreds of successful businesses using AllGrowth to accelerate their growth
          </p>
          <div className="flex items-center justify-center space-x-8 text-blue-200">
            <div className="text-center">
              <div className="text-2xl font-bold text-white">500+</div>
              <div className="text-sm">Businesses Served</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">150%</div>
              <div className="text-sm">Average Growth</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">98%</div>
              <div className="text-sm">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BookConsultation;